export enum WSEvent {
	Message = 'message',
	Error = 'error',
}
